import { FC } from 'react';
import { BaseIcon, IPropsIcon } from './BaseIcon';

interface IProps extends IPropsIcon {
  onClick?: () => void;
}

export const PenIcon: FC<IProps> = ({ size = 15, fill = 'none', onClick }) => {
  return (
    <BaseIcon size={size} viewBox='0 0 19 19' fill={fill} onClick={onClick && onClick}>
      <path
        d='M17.453 2.2995L16.1171 0.963562C15.6952 0.541687 15.0975 0.295593 14.535 0.295593C13.9725 0.295593 13.3749 0.541687 12.953 0.963562L0.542847 13.3737L0.120972 17.3815C0.0506592 17.8737 0.437378 18.2956 0.929565 18.2956C0.964722 18.2956 0.999878 18.2956 1.03503 18.2956L5.04285 17.8737L17.453 5.46356C18.3319 4.58466 18.3319 3.17841 17.453 2.2995ZM4.55066 16.7839L1.28113 17.1354L1.63269 13.8659L10.9139 4.58466L13.8319 7.50262L4.55066 16.7839ZM16.6444 4.69012L14.6053 6.72919L11.6874 3.81122L13.7264 1.77216C13.9374 1.56122 14.2186 1.42059 14.535 1.42059C14.8514 1.42059 15.1327 1.56122 15.3436 1.77216L16.6444 3.07294C17.1014 3.52997 17.1014 4.23309 16.6444 4.69012Z'
        fill='#111111'
      />
    </BaseIcon>
  );
};
